import tokenExpiredTemplate from '../../token-expired.html';

export const TokenExpiredComponent = {
  template: tokenExpiredTemplate,
};
